import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

type RedirectionProps = {
  redirectionConfig: Record<string, string>;
};

const Redirection = ({ redirectionConfig }: RedirectionProps) => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const { pathname, search, hash } = location;

    // Remove trailing and leading slashes if present
    const cleanPathname = pathname.replace(/\/$/, '').replace(/^\//, '');
    // Check if the current path matches any pattern in the redirection config
    const newPath = Object.keys(redirectionConfig).find(pattern => {
      const regex = new RegExp(`^${pattern.replace(/\*/g, '.*')}$`);
      return regex.test(cleanPathname);
    });

    // If a new path is found, navigate to it with preserved query params and hash
    if (newPath) {
      const targetPath = cleanPathname.replace(
        new RegExp(`^${newPath.replace(/\*/g, '(.*)')}$`),
        redirectionConfig[newPath].replace(/\*/g, '$1')
      );

      navigate(
        {
          pathname: targetPath,
          search,
          hash,
        },
        { replace: true }
      );
    }
  }, [location, navigate, redirectionConfig]);

  return null;
};

export default Redirection;
